import {client} from './services/client'

export  const tiersassureurs = {
    namespaced:true,
    state:{
        tiersassureurs:[],
    },
    mutations: {
        SET_TIERSASSUREUR (state,tiersassureurs){
            state.tiersassureurs = tiersassureurs
        },

    },
    actions: {
        getTiersAssureur({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/tiers_assureurs/get/'+id,
                })
                    .then((response)=>{
                        let tiersassureurs = response.data.tiersassureurs;
                        console.log(tiersassureurs);
                        commit('SET_TIERSASSUREUR',tiersassureurs)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setTiersAssureur({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/tiers_assureurs/save',
                    data:data,
                })
                    .then((response)=>{
                        let tiersassureurs = response.data.tiersassureurs;
                        commit('SET_TIERSASSUREUR',tiersassureurs);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteTiersAssureur({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/tiers_assureurs/delete/'+id,
                })
                    .then((response)=>{
                        let tiersassureurs = response.data.tiersassureurs;
                        commit('SET_TIERSASSUREUR',tiersassureurs);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getTiersAssureur: state  => {
            return state.tiersassureurs
        },
    }
};
